import React from 'react'
import { string } from 'prop-types'

import { MenuItem } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function Item({ itemTitle, itemThumbnailImage }) {
  return (
    <li className="cgt-model-search__suggestion">
      <img src={itemThumbnailImage} alt={itemTitle} width={60} height={40} />
      <MenuItem label={`${itemTitle}`} fluid />
    </li>
  )
}

Item.propTypes = {
  itemTitle: string.isRequired,
  itemThumbnailImage: string.isRequired,
}

export default Item
